import React from 'react';

export const getDisplayName = <P extends object>(Component: React.ComponentType<P>) => Component.displayName || Component.name || 'Component';
